import React from 'react';

import uuid from 'uuid';

import { StyledDevicePerformance } from './style/StyledDevicePerformance';

import NotFound from '../NotFound';

import DynamicComponent from '../../DynamicComponent';

const DevicePerformance = ({ data, channel, isLast }) => (
	<StyledDevicePerformance>
		<section>
			<h2>{data.title}</h2>
			<p>{data.content.text}</p>
		</section>

		{
			(data.charts.length > 0 ? (
				<div className="content-1200">
					<div className="content-charts">
						{data.charts.map(chart => (
							<DynamicComponent
								tag={chart.type}
								data={chart.data}
								captions={chart.captions}
								alias={chart.alias}
								channel={channel}
								key={uuid.v4()}
							/>
						))}
					</div>
				</div>
			) : (
				<section className="mt-4">
					<NotFound />
				</section>
				))
		}

		{!isLast ? <hr className="mt-4" /> : null}
	</StyledDevicePerformance>
);

export default DevicePerformance;
